const DEFAULT_LANGUAGE_LOCALE = "en-GB";

const LANGUAGE_TO_LOCALE: Record<string, string> = {
	"nl": "nl-NL",
	"de": "de-DE",
	"en": "en-GB",
	"vi": "vi-VN",
};

function extractLanguage(input: string): string | undefined {
	return input.match(/^([a-zA-Z]+)/)?.[1]?.toLowerCase();
}

function extractRegion(input: string): string | undefined {
	const parts = input.split(/[-_]/).filter(Boolean);
	const region = parts.length > 1 ? parts[1] : parts[0];
	return region?.toUpperCase();
}

export function getRegionLocale(region: string | null | undefined, language: string | null | undefined): string {
	const lang = language ? extractLanguage(language) : undefined;
	const reg = region ? extractRegion(region) : undefined;

	if (lang && reg) {
		return `${lang}-${reg}`;
	}

	if (lang) {
		return LANGUAGE_TO_LOCALE[lang] || DEFAULT_LANGUAGE_LOCALE;
	}

	if (reg) {
		const lang = extractLanguage(DEFAULT_LANGUAGE_LOCALE);
		return `${lang}-${reg}`;
	}

	return DEFAULT_LANGUAGE_LOCALE;
}

export function getDecimalSeparator(locale: string): string {
	try {
		return new Intl.NumberFormat(locale).format(1.1).charAt(1);
	} catch {
		return ",";
	}
}

export function getThousandSeparator(locale: string): string {
	try {
		return new Intl.NumberFormat(locale).format(10000).charAt(2);
	} catch {
		return ".";
	}
}

export function getStoredRegionLocale(): string {
	return localStorage.getItem("bosRegionLocale") || DEFAULT_LANGUAGE_LOCALE;
}
